export class TipoDocumentoFilter {
  sigla?: string;
  nombre?: string;
  conPlantilla?: boolean;
  esPublico?: boolean;
  estaActivo?: boolean;
}
